/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';

/**
 * 
 * @export
 * @interface LootBoxPrize
 */
export interface LootBoxPrize {
    /**
     * 
     * @type {string}
     * @memberof LootBoxPrize
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxPrize
     */
    name: string;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof LootBoxPrize
     */
    rewardConfig?: RewardConfigResponse;
    /**
     * 
     * @type {number}
     * @memberof LootBoxPrize
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxPrize
     */
    wonQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxPrize
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxPrize
     */
    sortOrder: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxPrize
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof LootBoxPrize
     */
    image?: string;
}

/**
 * Check if a given object implements the LootBoxPrize interface.
 */
export function instanceOfLootBoxPrize(value: object): value is LootBoxPrize {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('wonQuantity' in value) || value['wonQuantity'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function LootBoxPrizeFromJSON(json: any): LootBoxPrize {
    return LootBoxPrizeFromJSONTyped(json, false);
}

export function LootBoxPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'rewardConfig': json['rewardConfig'] == null ? undefined : RewardConfigResponseFromJSON(json['rewardConfig']),
        'quantity': json['quantity'],
        'wonQuantity': json['wonQuantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'sortOrder': json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}

export function LootBoxPrizeToJSON(json: any): LootBoxPrize {
    return LootBoxPrizeToJSONTyped(json, false);
}

export function LootBoxPrizeToJSONTyped(value?: LootBoxPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
        'quantity': value['quantity'],
        'wonQuantity': value['wonQuantity'],
        'weight': value['weight'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'image': value['image'],
    };
}

